var _path, _path2, _rect, _line, _line2, _line3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoxingX1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 8c-6 0-11 5-11 11v10c-3 1-5 4-5 7v9c0 7 6 13 13 13h16c7 0 13-6 13-13V26c0-6-5-11-11-11h-1V19c0-6-5-11-11-11z",
    fill: "#1a1a1a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 8c-6 0-11 5-11 11v10c-3 1-5 4-5 7v9c0 7 6 13 13 13h16c7 0 13-6 13-13V26c0-6-5-11-11-11h-1V19c0-6-5-11-11-11z",
    fill: "none",
    stroke: "#333",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 42,
    width: 24,
    height: 8,
    rx: 2,
    fill: "#e0e0e0"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 26,
    y1: 30,
    x2: 26,
    y2: 40,
    stroke: "#ffffff",
    strokeWidth: 1.2,
    opacity: 0.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 28,
    x2: 32,
    y2: 40,
    stroke: "#ffffff",
    strokeWidth: 1.2,
    opacity: 0.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 38,
    y1: 30,
    x2: 38,
    y2: 40,
    stroke: "#ffffff",
    strokeWidth: 1.2,
    opacity: 0.6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxingX1);
export default __webpack_public_path__ + "static/media/boxing-x1.b1c72acfb2ebc04ae9c6ede84d607da8.svg";
export { ForwardRef as ReactComponent };